import "./Home.css";
import React, { useState, useEffect } from "react";
import logoDark from "../images/logo_dark.png";

const Home = () => {
  const [images, setImages] = useState([]);
  const [index, setIndex] = useState(0);
  const [showNavbar, setShowNavbar] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  const goNext = () => {
    setIndex((prev) => (prev + 1) % images.length);
  };

  const goPrev = () => {
    setIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [images.length]);

  useEffect(() => {
    fetch("backend/getHeroImages.php")
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch images");
        return res.json();
      })
      .then((data) => {
        const fullPaths = data.map((img) => "images/hero/" + img);
        setImages(fullPaths);
      })
      .catch((err) => {
        console.error("Image fetch error:", err);
      });
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY && currentScrollY > 80) {
        setShowNavbar(false);
      } else {
        setShowNavbar(true);
      }
      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  return (
    <div className="home">
      <div
        className="hero"
        style={{
          backgroundImage:
            images.length > 0 ? `url(${images[index]})` : "none",
        }}
      >
        <nav className={`navbar ${showNavbar ? "visible" : "hidden"}`}>
          <div
            className="logo-container"
            onClick={() => {
              const targetEl = document.getElementById("home");
              if (targetEl) {
                targetEl.scrollIntoView({ behavior: "smooth" });
                window.history.pushState(null, "", "/home");
              }
            }}
            style={{ cursor: "pointer" }}
          >
            <img src={logoDark} alt="Jooloo Logo" />
          </div>

          <ul className="nav-links">
            <li>
              <a href="#home" className="nav-link">
                Home
              </a>
            </li>
            <li>
              <a href="#product" className="nav-link">
                Product
              </a>
            </li>
            <li>
              <a href="#showcase" className="nav-link">
                Showcase
              </a>
            </li>
            <li>
              <a href="#review" className="nav-link">
                Reviews
              </a>
            </li>
            <li>
              <a href="#about-us" className="nav-link">
                About Us
              </a>
            </li>
            <li>
              <a href="#contact" className="nav-link">
                Contact
              </a>
            </li>
          </ul>
        </nav>

        <div className="hero-arrows">
          <button className="arrow-btn left-arrow" onClick={goPrev}>
            <svg xmlns="http://www.w3.org/2000/svg">
              <path d="M15.293 3.293 6.586 12l8.707 8.707 1.414-1.414L9.414 12l7.293-7.293-1.414-1.414z" />
            </svg>
          </button>
          <button className="arrow-btn right-arrow" onClick={goNext}>
            <svg xmlns="http://www.w3.org/2000/svg">
              <path d="M7.293 4.707 14.586 12l-7.293 7.293 1.414 1.414L17.414 12 8.707 3.293 7.293 4.707z" />
            </svg>
          </button>
        </div>
      </div>

      <div className="why-section">
        <div className="why-title">
          <span>Why</span>
          <br />
          <span>Choosing Us</span>
        </div>
        <div className="features">
          <div className="feature">
            <h3>Many Choices</h3>
            <p>
              We provide many unique workspace choices so that you can choose
              the workspace to your liking.
            </p>
            <button
              className="info-btn"
              onClick={() => {
                const targetEl = document.getElementById("product");
                if (targetEl) {
                  targetEl.scrollIntoView({ behavior: "smooth" });
                  window.history.pushState(null, "", "/product");
                }
              }}
            >
              More Info <span className="arrow">→</span>
            </button>
          </div>
          <div className="feature">
            <h3>Affordable Price</h3>
            <p>
              You can get a workspace of the highest quality at an affordable
              price and still enjoy the facilities that are only here.
            </p>
            <button
              className="info-btn"
              onClick={() => {
                const targetEl = document.getElementById("showcase");
                if (targetEl) {
                  targetEl.scrollIntoView({ behavior: "smooth" });
                  window.history.pushState(null, "", "/showcase");
                }
              }}
            >
              More Info <span className="arrow">→</span>
            </button>
          </div>
          <div className="feature">
            <h3>Material Integrity</h3>
            <p>
              We thoughtfully select materials that respect nature, elevate design, and age gracefully.
            </p>
            <button
              className="info-btn"
              onClick={() => {
                const targetEl = document.getElementById("materials");
                if (targetEl) {
                  targetEl.scrollIntoView({ behavior: "smooth" });
                  window.history.pushState(null, "", "/materials");
                }
              }}
            >
              More Info <span className="arrow">→</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
